import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';

const PSSSOArrival = loadable(() => import('./PSSSOArrival'), {
  fallback: null,
});
const PSSSODeparture = loadable(() => import('./PSSSODeparture'), {
  fallback: null,
});
const PSSSOArrivalV2 = loadable(() => import('./PSSSOArrivalV2'), {
  fallback: null,
});
const PSSSODepartureV2 = loadable(() => import('./PSSSODepartureV2'), {
  fallback: null,
});

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

function pruserviceSSO() {
  return (
    <>
      <Routes>
        <Route path="transaction/:transaction" element={<PSSSOArrival />} />
        <Route
          path="transaction/:transaction/policy/:encryptedPolicyNo"
          element={<PSSSOArrival />}
        />
        <Route
          path="linkto/:transaction"
          element={
            <AuthProvider liffId={config.liff_id.psssoDeparture}>
              <CheckCMSNewVersionLayer>
                <PSSSODeparture />
              </CheckCMSNewVersionLayer>
            </AuthProvider>
          }
        />
        <Route
          path="v2/transaction/:transaction"
          element={<PSSSOArrivalV2 />}
        />
        <Route
          path="v2/transaction/:transaction/policy/:encryptedPolicyNo"
          element={<PSSSOArrivalV2 />}
        />
        <Route
          path="v2/linkto/:transaction"
          element={
            <AuthProvider liffId={config.liff_id.psssoDeparture}>
              <CheckCMSNewVersionLayer>
                <PSSSODepartureV2 />
              </CheckCMSNewVersionLayer>
            </AuthProvider>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default pruserviceSSO;
